
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */


const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
  return <div {...props}/>
};

const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p>{`Die Naturwissenschaft machte nicht nur das Grabtuch von Turin zum simplen
Leinenstoff. Sie räumte auch auf mit der Illusion von der Einzigartigkeit des
Menschen als Ebenbild Gottes. Für die Biologie ist der Mensch ein Primat neben
anderen. Für die Physik ist er eine Ansammlung von Atomen, für die Chemie eine
Kombination aus gasförmigen und festen Stoffen. Die Informatik vergleicht das
menschliche Gehirn mit einer Festplatte, die Medizin wird zu Support und
Servicestelle, Ärztinnen und Ärzte zu Dateninterpreten von Schrittzahl,
Herzschlag, Blutdruck und Hirnströmen.`}</p>
    <p>{`Wenn das Gehirn so verstanden wird, werden ihm die Computer wie beim Schachspiel
oder beim Go-Denkspiel früher oder später überlegen sein – so erklärt sich die
aktuelle Schreckensvision einer Macht der Roboter. Wenn das Suchtzentrum im
menschlichen Gehirn lokalisiert sein wird, dann wird dies aus
naturwissenschaftlicher Sicht die aufwendige Suche nach Gründen der Sucht in der
Biografie von Drogenabhängigen erübrigen. Stereotaktische Eingriffe ins Gehirn
ersetzen dann aufwendige Gesprächstherapie und Begleitung.`}</p>
    <p>{`Wenn der Mensch entzaubert ist, kann er auch sozialtechnisch verändert werden.
Beispielhaft dafür ist die Gentechnologie, die ins Erbgut des Menschen
eingreift. Das wird man aus säkularer Sicht gut finden, weil so Krankheiten
verhindert, die Lebenserwartung erhöht und genetische Risiken minimiert werden
können. Die traditionellen Religionen aus der Achsenzeit stehen diesen
Eingriffen kritisch bis ablehnend gegenüber, weil aus ihrer Sicht Gott und nicht
der Gentechniker im Labor den Menschen schafft. Habermas versucht nun
beispielhaft, dieses religiöse Bild ins Säkulare einfliessen zu lassen, und
fragt sich, welche moralische Haltung zur Gentechnologie sich dadurch ergibt:
Den Menschen als Ebenbild Gottes zu sehen, bedeutet säkular, sich für eine
Stärkung seiner Autonomie einzusetzen – gentechnologische Eingriffe in die
Keimbahn schwächen dort seine Autonomie, wo sie Eigenschaften des neugeborenen
Lebens durch Eingriffe festlegen.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;